import React from 'react';
import { Link } from 'react-router-dom';
import { useGetMyAgenticSessionsQuery } from '../../utils/api_service/agenticAssessmentApi';
import { AgenticSessionStatus } from '../../utils/types/agentic_assessment_types';

const ACTION: Record<AgenticSessionStatus, string | null> = {
  'Invite Sent': 'Start',
  'In Progress': 'Continue',
  Completed: null,
  Expired: null,
};

/** The candidate's written interviews, shown on their assessments page. Renders nothing when there are none. */
export const AgenticSessionsList: React.FC = () => {
  const { data: sessions = [] } = useGetMyAgenticSessionsQuery(undefined, { refetchOnMountOrArgChange: true });
  if (!sessions.length) return null;

  return (
    <div className='mb-4 flex flex-col gap-2'>
      <p className='text-base font-semibold text-gray-900'>Written interviews</p>
      { sessions.map((s) => {
        const action = ACTION[s.status];
        return (
          <div key={s.sessionId} className='flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3'>
            <div className='min-w-0'>
              <div className='truncate text-sm font-semibold text-slate-900'>{ s.jobTitle }</div>
              <div className='truncate text-xs text-slate-500'>
                { s.organizationName } · { s.status === 'Invite Sent' && s.expiresAt
                  ? `start by ${new Date(s.expiresAt * 1000).toLocaleDateString()}`
                  : s.status }
              </div>
            </div>
            { action && (
              <Link
                  to={`/agentic-assessment/${s.sessionId}`}
                  className='shrink-0 rounded-lg bg-emerald-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-emerald-700'
              >
                { action }
              </Link>
            ) }
          </div>
        );
      }) }
    </div>
  );
};
